/**
 * Displays a row in the periodic table
 * Child of PeriodicTable component
 */
import React from "react";
import PeriodicTableCell from "./PeriodicTableCell";
import styled from "styled-components";

const PeriodicTableRow = ({ row }) => {
  return (
    <TableRow>
      {row.map((cell, index) => (
        <PeriodicTableCell key={index} value={cell.value} index={cell.index} />
      ))}
    </TableRow>
  );
};

export default PeriodicTableRow;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
`;
